import React from 'react';
import ReactDOM from 'react-dom/client';
import './lang/i18n.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.scss';
import { CartProvider } from './contexts/CartContext';
import { SettingProvider } from './contexts/SettingContext';
import { WishlistProvider } from './providers/WishlistProvider';
import ScrollToTop from './components/ScrollToTop';
import './styles/styles-theme.scss';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <SettingProvider>
        <WishlistProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </WishlistProvider>
      </SettingProvider>
    </BrowserRouter>
  </HelmetProvider>
);
reportWebVitals();
